import React, { useState, useEffect } from 'react';
import { flushSync } from "react-dom";
import { Row, Col, FormGroup, Label, Input, Button, Card, CardBody, Spinner, CardHeader, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Select, { components } from 'react-select';
import { FaChevronRight, FaChevronLeft, FaTrash, FaPlus, FaUpload } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import axios from 'axios';
import uuid from 'react-uuid';
import CouncilAndLandInfo from '../Enterprises/CouncilAndLandInfo';
import Contacts from '../Enterprises/Contacts';
import StockNumbers from '../Enterprises/StockNumbers';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import { useNavigate } from "react-router-dom";

const Enterprises = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {
    const roleName = localStorage.getItem("roleName"); const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    const isAddEditItem = localStorage.getItem("isAddEditItem");
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [enterprisesList, setEnterprisesList] = useState([]); const [savingEnterprises, setSavingEnterprises] = useState('');
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [supplyCompany, setSupplyCompany] = useState(0);
    const [isHavingFarmWriteAccess, setIsHavingFarmWriteAccess] = useState(false);
    const [uniqueIdentifier, setUniqueIdentifier] = useState('');
    const [supplyCompanyAccess, setSupplyCompanyAccess] = useState(0);
    const [ruralProfessionalOrganisation, setRuralProfessionalOrganisation] = useState(0);
    const [ruralProfessional, setRuralProfessional] = useState('');
    const [ruralProfessionalAccess, setRuralProfessionalAccess] = useState(0);
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [optionalPages_Effluent, setOptionalPages_Effluent] = useState(false);
    const [optionalPages_Biosecurity, setOptionalPages_Biosecurity] = useState(false);
    const [optionalPages_ContaminantSelfEvaluation, setOptionalPages_ContaminantSelfEvaluation] = useState(false);
    const [show_HistoricalActions, setShow_HistoricalActions] = useState(false);
    const [show_SectionComment, setShow_SectionComment] = useState(false);
    const [optionalPages_FreshwaterIrrigation, setOptionalPages_FreshwaterIrrigation] = useState(false);
    const [optionalPages_WinterGrazing, setOptionalPages_WinterGrazing] = useState(false);
    const [optionalPages_Cropping, setOptionalPages_Cropping] = useState(false);
    const [optionalPages_Biodiversity, setOptionalPages_Biodiversity] = useState(false);
    const [optionalPages_GreenhouseGass, setOptionalPages_GreenhouseGass] = useState(false);
    const [farmSystemType, setFarmSystemType] = useState('');
    const [farmingActivities, setFarmingActivities] = useState('');
    const [totalArea, setTotalArea] = useState('');
    const [leaseArea, setLeaseArea] = useState('');
    const [irrigatedArea, setIrrigatedArea] = useState('');
    const [savingAssociations, setSavingAssociations] = useState(false);
    const [savingEnterprisesOptions, setSavingEnterprisesOptions] = useState(false);
    const [savingFarmSystem, setSavingFarmSystem] = useState(false);
    const [savingFarmStory, setSavingFarmStory] = useState(false);
    const [enterpriseTypeList, setEnterpriseTypeList] = useState([]);
    const [enterpriseCategoryList, setEnterpriseCategoryList] = useState([]);
    const [enterpriseTypeListSelectedValues, setEnterpriseTypeListSelectedValues] = useState([]);
    const [enterpriseTypeSelectedValues, setEnterpriseTypeSelectedValues] = useState('');
    const [enterprises, setEnterprises] = useState({ Section: 'Enterprises', SectionName: 'Enterprise & Farm Detail', isWizardCompleted: false });
    const [propertyDetails, setPropertyDetails] = useState({ Name: '', Address1: '', Address2: '', Address3: '', Address4: '', FarmLocation: '', nzBusinessNumber: '', infdpUniqueFreshwaterFarmPlanId: '', ExecutiveSummaryComment :''});
    const [savingPropertyDetails, setSavingPropertyDetails] = useState(false);
    const [farmStory, setFarmStory] = useState({ FarmStory: '', FarmStoryGoals: '', IntrestingFeatures: '', Concerns: '' });
    const [tellUsAbout, setTellUsAbout] = useState({ RiparianAreas: '', AreasRetired: '', FencingOfWaterways: '', StockPolicy: '', Other: '' });
    const [savingTellUsAbout, setSavingTellUsAbout] = useState(false);
    const [isHaveresponsible, setIsHaveresponsible] = useState(false);
    const [regulatoryRequirementDetails, setRegulatoryRequirementDetails] = useState({ RegulatoryRequirementDetails: '', FWFPToMeetAnyOtherRegulatoryRequirement: 'Yes', IsAnyNewPhsyicalWorks: 'No', AnyNewPhsyicalWorksDetails : '' });
    const [savingRegulatoryRequirementDetails, setSavingRegulatoryRequirementDetails] = useState(false);
    const [enterpriseRows, setEnterpriseRows] = useState([]);
    const [enterpriseDetails, setEnterpriseDetails] = useState({ IsPastorallanduse: false, MeatCompanyList: [], IsAnyMeatCompany: 'No', selectedCompanies: [] });
    const [regulatoryRequirementsRows, setRegulatoryRequirementsRows] = useState([]);
    const [enterpriseRowCount, setEnterpriseRowCount] = useState(0);
    const [regulatoryRequirementsRowCount, setRegulatoryRequirementsRowCount] = useState(0);
    const [formErrors, setFormErrors] = useState([]);
    const [uploadType, setUploadType] = useState('NewPhsyicalWork');
    const [documentUploadList, setDocumentUploadList] = useState([]);
    const [deleteDocumentPopup, setDeleteDocumentPopup] = useState({ showDeleteDocumentPopup: false, itemId: 0, date: '', daetails: '', fileName: '' });
    let inputFile = [];
    const [editorStateFarmStory, setEditorStateFarmStory] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));

    const [editorStateFarmStoryGoals, setEditorStateFarmStoryGoals] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateIntrestingFeatures, setEditorStateIntrestingFeatures] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateConcerns, setEditorStateConcerns] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateRiparianAreas, setEditorStateRiparianAreas] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateAreasRetired, setEditorStateAreasRetired] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateFencingOfWaterways, setEditorStateFencingOfWaterways] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateStockPolicy, setEditorStateStockPolicy] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateOther, setEditorStateOther] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));

    const [imageFile, setImageFile] = useState('');
    const [imagePreviewUrl, setImagePreviewUrl] = useState('');
    const [imageName, setImageName] = useState('');
    const [imagePhysicalFilename, setImagePhysicalFilename] = useState('');
    const [imagePhysicalFilepath, setImagePhysicalFilepath] = useState('');

    useEffect(() => {
        setLoading(true);
        populateItemData();
    }, []);

    const gotoFarmSettings = () => {
        navigate('/farmsettings', { state: { farmId: farmId } });
    }

    const Option = (props) => {
        return (
            <div>
                <components.Option {...props}>
                    <input
                        type="checkbox"
                        checked={props.isSelected}
                        onChange={() => null}
                    />{" "}
                    <label>{props.label}</label>
                </components.Option>
            </div>
        );
    };
    const populateItemData = async () => {
        try {
            const response = await axios.get(
                '/api/enterprises/getenterprisedetails/', {
                params: { Id: farmId, UserId: userId }
            }
            );
            setEnterprisesList(response.data.content);
            flushSync(() => {
                setEnterprisesList(response.data.content);
            });

            if (response.data.content.enterprises.selectedEnterpriseTypeList.length > 0) {
                var setEnterpriseTypeSelectedValues1 = '';
                response.data.content.enterprises.selectedEnterpriseTypeList.forEach(function (element) {
                    if (setEnterpriseTypeSelectedValues1 == '') {
                        setEnterpriseTypeSelectedValues1 = element.value;
                    }
                    else {
                        setEnterpriseTypeSelectedValues1 = setEnterpriseTypeSelectedValues1 + ',' + element.value;
                    }
                });
                setEnterpriseTypeSelectedValues(setEnterpriseTypeSelectedValues1);
                setEnterpriseTypeListSelectedValues(response.data.content.enterprises.selectedEnterpriseTypeList);
            }
            else {
                setEnterpriseTypeListSelectedValues([]);
            }
            setIsHavingFarmWriteAccess(response.data.content.isHavingFarmWriteAccess);
            setSupplyCompany(response.data.content.enterprises.supplyCompany);
            setSupplyCompanyAccess(response.data.content.enterprises.supplycompanyAccess);
            setUniqueIdentifier(response.data.content.enterprises.uniqueIdentifier);
            setRuralProfessionalOrganisation(response.data.content.enterprises.ruralProfessionalOrganisation);
            setRuralProfessional(response.data.content.enterprises.ruralProfessional);
            setRuralProfessionalAccess(response.data.content.enterprises.ruralProfessionalAccess);
            setOptionalPages_Effluent(response.data.content.enterprises.optionalPages_Effluent);
            setOptionalPages_Biosecurity(response.data.content.enterprises.optionalPages_Biosecurity);
            setOptionalPages_FreshwaterIrrigation(response.data.content.enterprises.optionalPages_FreshwaterIrrigation);
            setOptionalPages_WinterGrazing(response.data.content.enterprises.optionalPages_WinterGrazing);
            setOptionalPages_Cropping(response.data.content.enterprises.optionalPages_Cropping);
            setOptionalPages_Biodiversity(response.data.content.enterprises.optionalPages_Biodiversity);
            setOptionalPages_GreenhouseGass(response.data.content.enterprises.optionalPages_GreenhouseGass);
            setOptionalPages_ContaminantSelfEvaluation(response.data.content.enterprises.optionalPages_ContaminantSelfEvaluation);
            setShow_HistoricalActions(response.data.content.enterprises.show_HistoricalActions);
            setShow_SectionComment(response.data.content.enterprises.show_SectionComment);
            setFarmSystemType(response.data.content.enterprises.farmSystemType);
            setFarmingActivities(response.data.content.enterprises.farmingActivities);
            setTellUsAbout(response.data.content.enterprises.tellUsAbout);
            setEnterpriseTypeList(response.data.content.enterpriseTypes);
            setEnterpriseCategoryList(response.data.content.enterpriseCategoryList);
            setEnterprises({ ...enterprises, isWizardCompleted: response.data.content.isFWFPCompleted })
            setTotalArea(response.data.content.totalArea);
            setLeaseArea(response.data.content.leaseArea);
            setIrrigatedArea(response.data.content.irrigatedArea);
            setPropertyDetails({
                ...propertyDetails, Name: response.data.content.enterprises.name, Address1: response.data.content.enterprises.address1, Address2: response.data.content.enterprises.address2,
                Address3: response.data.content.enterprises.address3, Address4: response.data.content.enterprises.address4, FarmLocation: response.data.content.enterprises.farmLocation,
                nzBusinessNumber: response.data.content.enterprises.nzBusinessNumber, infdpUniqueFreshwaterFarmPlanId: response.data.content.enterprises.infdpUniqueFreshwaterFarmPlanId,
                ExecutiveSummaryComment: response.data.content.enterprises.executiveSummaryComment
            });
            const contentFarmStory = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.farmStory == null ? '' : response.data.content.enterprises.farmStory))
            setEditorStateFarmStory(EditorState.createWithContent(contentFarmStory));

            const contentFarmStoryGoals = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.farmStoryGoals == null ? '' : response.data.content.enterprises.farmStoryGoals))
            setEditorStateFarmStoryGoals(EditorState.createWithContent(contentFarmStoryGoals));

            const contentIntrestingFeatures = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.intrestingFeatures == null ? '' : response.data.content.enterprises.intrestingFeatures))
            setEditorStateIntrestingFeatures(EditorState.createWithContent(contentIntrestingFeatures));

            const contentConcerns = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.concerns == null ? '' : response.data.content.enterprises.concerns))
            setEditorStateConcerns(EditorState.createWithContent(contentConcerns));

            const contentRiparianAreas = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.riparianAreas == null ? '' : response.data.content.enterprises.riparianAreas))
            setEditorStateRiparianAreas(EditorState.createWithContent(contentRiparianAreas));

            const contentAreasRetired = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.areasRetired == null ? '' : response.data.content.enterprises.areasRetired))
            setEditorStateAreasRetired(EditorState.createWithContent(contentAreasRetired));

            const contentFencingOfWaterways = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.fencingOfWaterways == null ? '' : response.data.content.enterprises.fencingOfWaterways))
            setEditorStateFencingOfWaterways(EditorState.createWithContent(contentFencingOfWaterways));

            const contentStockPolicy = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.stockPolicy == null ? '' : response.data.content.enterprises.stockPolicy))
            setEditorStateStockPolicy(EditorState.createWithContent(contentStockPolicy));

            const contentOther = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.other == null ? '' : response.data.content.enterprises.other))
            setEditorStateOther(EditorState.createWithContent(contentOther));

            setFarmStory({
                ...farmStory, FarmStory: response.data.content.enterprises.farmStory, FarmStoryGoals: response.data.content.enterprises.farmStoryGoals
                , IntrestingFeatures: response.data.content.enterprises.intrestingFeatures, Concerns: response.data.content.enterprises.concerns
            });
            setTellUsAbout({
                ...tellUsAbout, RiparianAreas: response.data.content.enterprises.riparianAreas, AreasRetired: response.data.content.enterprises.areasRetired
                , FencingOfWaterways: response.data.content.enterprises.fencingOfWaterways, StockPolicy: response.data.content.enterprises.stockPolicy, Other: response.data.content.enterprises.other
            });
            setRegulatoryRequirementDetails({
                ...regulatoryRequirementDetails, FWFPToMeetAnyOtherRegulatoryRequirement: response.data.content.enterprises.fwfpToMeetAnyOtherRegulatoryRequirement,
                RegulatoryRequirementDetails: response.data.content.enterprises.regulatoryRequirementDetails, IsAnyNewPhsyicalWorks: response.data.content.enterprises.isAnyNewPhsyicalWorks,
                AnyNewPhsyicalWorksDetails: response.data.content.enterprises.anyNewPhsyicalWorksDetails
            })
            setEnterpriseRows(response.data.content.farmEnterprises);

            var enterprisesValue = response.data.content.enterprises;
            //Selected enterprise Type
            let selectedMeatCompanies = []

            if (enterprisesValue.selectedMeatCompaniesList != "" && enterprisesValue.selectedMeatCompaniesList != null) {
                let selectedMeatCompaniesArray = [];

                selectedMeatCompaniesArray = enterprisesValue.selectedMeatCompaniesList.split(',');

                response.data.content.meatCompanyList.map(type => {
                    if (selectedMeatCompaniesArray.includes(String(type.value))) {
                        selectedMeatCompanies.push({
                            value: type.value,
                            label: type.label                            
                        })
                    }
                })
            }

            setEnterpriseDetails({ IsPastorallanduse: enterprisesValue.isPastorallanduse, MeatCompanyList: response.data.content.meatCompanyList, IsAnyMeatCompany: enterprisesValue.isAnyMeatCompany, selectedCompanies: selectedMeatCompanies })
            setRegulatoryRequirementsRows(response.data.content.regulatoryRequirements);
            if (response.data.content.farmEnterprises.length > 0) {
                setEnterpriseRowCount(response.data.content.farmEnterprises.length);
            }
            checkAlreadyIsresponsibleChecked();
            getUploadedDocuments();
            if (response.data.content.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName == response.data.content.section.routePath);
                if (section.length > 0 != null) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }

            if (response.data.content.enterprises.propertyImageName != null) {
                setImageName(response.data.content.enterprises.propertyImageName);
                setImagePhysicalFilename(response.data.content.enterprises.propertyImagePhysicalName);
                setImagePhysicalFilepath(response.data.content.enterprises.propertyImagePath);
                setImagePreviewUrl(response.data.content.enterprises.propertyImageRelativePath);
            }
            else {
                setImageName(null);
                setImagePhysicalFilename(null);
                setImagePhysicalFilepath(null);
                setImagePreviewUrl(null);
            }

            setLoading(false);
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
            setLoading(false);
        }
    }

    const handleRegulatoryRequirementRowsAddRow = () => {
        const item = {
            regulatoryRequirement: "",
            condition: "", id: 0
        };
        setRegulatoryRequirementsRows([...regulatoryRequirementsRows, item]);
    };

    const handleRegulatoryRequirementRowsRemoveSpecificRow = (idx) => () => {
        const tempRows = [...regulatoryRequirementsRows]
        tempRows.splice(idx, 1)
        setRegulatoryRequirementsRows(tempRows);
    }

    const checkAlreadyIsresponsibleChecked = async () => {
        let alreadyChecked = false;
        try {
            const response = await axios.get(
                '/api/enterprises/GetContacts/', {
                params: { Id: farmId }
            }
            );

            for (var i = 0; i < response.data.content.farmContacts.length; i++) {
                if (response.data.content.farmContacts[i].isResponsible == true) {
                    alreadyChecked = true;
                }
            }
            setIsHaveresponsible(alreadyChecked);
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
        }
    }

    const getUploadedDocuments = async () => {
        try {
            const response = await axios.get(
                '/api/upload/GetUploadedDocuments/', {
                    params: { Id: farmId, UploadType: uploadType, FarmId: farmId }
            }
            );
            if (response.data.status) {
                setDocumentUploadList(response.data.content);
                let tempErrors = [];
                response.data.content.forEach(function (element) {
                    const error = {
                        fileError: ''
                    };
                    tempErrors.push(error);
                });
                setFormErrors(tempErrors);
            }

        } catch (err) {
            console.log(err);
        }
    }

    const handleRegulatoryRequirementChange = idx => e => {
        const tempRows = [...regulatoryRequirementsRows];
        tempRows[idx].regulatoryRequirement = e.target.value;
        setRegulatoryRequirementsRows(tempRows);
    };

    const handleRegulatoryRequirementConditionChange = idx => e => {
        const tempRows = [...regulatoryRequirementsRows];
        tempRows[idx].condition = e.target.value;
        setRegulatoryRequirementsRows(tempRows);
    };

    const handleEnterpriseCategoryChange = idx => e => {
        const tempRows = [...enterpriseRows];
        tempRows[idx].enterpriseCategory = e.target.value;
        setEnterpriseRows(tempRows);
        var isPastorallanduse = false;
        tempRows.forEach(function (type) {
            if (type.enterpriseCategory == 'Pastoral land use') {
                isPastorallanduse = true;
            }
        });
        setEnterpriseDetails({
            ...enterpriseDetails, IsPastorallanduse: isPastorallanduse
        })
    };

    const handleEnterpriseTypeChange = idx => e => {
        const tempRows = [...enterpriseRows];
        tempRows[idx].enterpriseType = parseInt(e.target.value);
        setEnterpriseRows(tempRows);
    };

    const handleFarmingActivityChange = idx => e => {
        const tempRows = [...enterpriseRows];
        tempRows[idx].farmingActivity = e.target.value;
        setEnterpriseRows(tempRows);
    };

    const handleOverviewOfFarmingActivitiesChange = idx => e => {
        const tempRows = [...enterpriseRows];
        tempRows[idx].overviewOfFarmingActivities = e.target.value;
        setEnterpriseRows(tempRows);
    };

    const handleEnterpriseRowsRemoveSpecificRow = (idx) => () => {
        const tempRows = [...enterpriseRows]
        tempRows.splice(idx, 1)
        setEnterpriseRows(tempRows);
        var isPastorallanduse = false;
        tempRows.forEach(function (type) {
            if (type.enterpriseCategory == 'Pastoral land use') {
                isPastorallanduse = true;
            }
        });
        setEnterpriseDetails({
            ...enterpriseDetails, IsPastorallanduse: isPastorallanduse
        })

    }

    const handleEnterpriseRowsAddRow = () => {
        const item = {
            enterpriseCategory:'Select',enterpriseType: 0, enterpriseType: "", overviewOfFarmingActivities:''
        };
        setEnterpriseRows([...enterpriseRows, item]);
    };

    const handleEnterprisesOptionsSubmit = async (e) => {
        e.preventDefault()
        setSavingEnterprisesOptions(true);
        await saveFarmDetails();
        window.location.reload(true);
    };

    const handleEnterpriseRowsSubmit = async (e) => {
        e.preventDefault()
        let tempEnterpriseRows = [...enterpriseRows];
        if (tempEnterpriseRows.length > 0) {
            setSavingEnterprises(true);
            let form = {
                FarmId: farmId,
                FarmEnterprises: [],
                UserId: userId,
                IsAnyMeatCompany: enterpriseDetails.IsPastorallanduse == true ?  enterpriseDetails.IsAnyMeatCompany : 'No',
                MeatCompanies: enterpriseDetails.IsPastorallanduse == true && enterpriseDetails.IsAnyMeatCompany == 'Yes' ? enterpriseDetails.selectedCompanies.toString() : ''
            }
            for (var i = 0; i < tempEnterpriseRows.length; i++) {
                var enterpriseList = tempEnterpriseRows.filter(x => x.enterpriseType == tempEnterpriseRows[i].enterpriseType && x.farmingActivity == tempEnterpriseRows[i].farmingActivity);
                if (enterpriseList.length > 1) {
                    toast.error("You can not add duplicate enterprises!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                    setSavingEnterprises(false);
                    return false;
                }
                if (tempEnterpriseRows[i].enterpriseType == 0 || tempEnterpriseRows[i].enterpriseType == null || tempEnterpriseRows[i].enterpriseType == undefined || tempEnterpriseRows[i].enterpriseType == '') {
                    toast.error("Select enterprise!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                    setSavingEnterprises(false);
                    return false;
                }
                var obj = {};
                obj.Id = tempEnterpriseRows[i].id;
                obj.FarmId = farmId;
                obj.FarmingActivity = tempEnterpriseRows[i].farmingActivity;
                obj.EnterpriseType = tempEnterpriseRows[i].enterpriseType;
                obj.overviewOfFarmingActivities = tempEnterpriseRows[i].overviewOfFarmingActivities;
                obj.EnterpriseCategory = tempEnterpriseRows[i].enterpriseCategory;
                form.FarmEnterprises.push(obj);
            }
            const response = await axios.post(
                '/api/enterprises/SaveFarmEnterprises/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.data != null) {
                if (response.data.status) {
                    toast.success("Enterprises & Farming Activities Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                    setSavingEnterprises(false);
                    setEnterpriseRows(response.data.content);
                    setEnterpriseRowCount(response.data.content.length);
                }
            }
        }
        else {
            toast.error("Please add atleast one enterprise record for implementing plan to move forward ...", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
    };

    const handleFarmStorySubmit = async (e) => {
        e.preventDefault()
        setSavingFarmStory(true);
        saveFarmDetails();
    };

    const handleFarmSystemSubmit = async (e) => {
        e.preventDefault()
        setSavingFarmSystem(true);
        saveFarmDetails();
    };

    const handleAssociationsSubmit = async (e) => {
        e.preventDefault()
        setSavingAssociations(true);
        saveFarmDetails();
    };

    const handlePropertyDetailsSubmit = async (e) => {
        e.preventDefault()
        setSavingPropertyDetails(true);
        saveFarmDetails();
    };

    const handleRegulatoryRequirementDetailsSubmit = async (e) => {
        e.preventDefault()
        setSavingRegulatoryRequirementDetails(true);

        let tempRegulatoryRequirementsRows = [...regulatoryRequirementsRows];
        if (regulatoryRequirementDetails.IsAnyNewPhsyicalWorks == "No") {
            regulatoryRequirementDetails.AnyNewPhsyicalWorksDetails = "";
        }
        let form = {
            FarmId: farmId,
            RegulatoryRequirements: [],
            UserId: userId,
            FWFPToMeetAnyOtherRegulatoryRequirement: regulatoryRequirementDetails.FWFPToMeetAnyOtherRegulatoryRequirement,
            IsAnyNewPhsyicalWorks: regulatoryRequirementDetails.IsAnyNewPhsyicalWorks,
            AnyNewPhsyicalWorksDetails: regulatoryRequirementDetails.AnyNewPhsyicalWorksDetails
        }
        for (var i = 0; i < tempRegulatoryRequirementsRows.length; i++) {
            var obj = {};
            obj.Id = tempRegulatoryRequirementsRows[i].id;
            obj.RegulatoryRequirement = tempRegulatoryRequirementsRows[i].regulatoryRequirement;
            obj.Condition = tempRegulatoryRequirementsRows[i].condition;
            form.RegulatoryRequirements.push(obj);
        }
        const response = await axios.post(
            '/api/enterprises/SaveRegulatoryRequirements/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                handleRecordRowsSubmit();
                toast.success("Other Regulatory Requirements Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setSavingRegulatoryRequirementDetails(false);
                setRegulatoryRequirementsRows(response.data.content);
            }
        }

    };

    const handleTellUsAboutSubmit = async (e) => {
        e.preventDefault()
        setSavingTellUsAbout(true);
        saveFarmDetails();
    };

    const handlEnterpriseTypeSelectChange = (e) => {
        setEnterpriseTypeSelectedValues('');
        var enterpriseTypeSelectedValues = '';
        setEnterpriseTypeListSelectedValues(e);
        e.forEach(function (element) {
            if (enterpriseTypeSelectedValues == '') {
                enterpriseTypeSelectedValues = element.value;
            }
            else {
                enterpriseTypeSelectedValues = enterpriseTypeSelectedValues + ',' + element.value;
            }
        });
        setEnterpriseTypeSelectedValues(enterpriseTypeSelectedValues);

        if (!optionalPages_Effluent) {
            const selectedValues = enterpriseTypeSelectedValues.toString().includes(',') ? enterpriseTypeSelectedValues.split(',') : enterpriseTypeSelectedValues.toString();
            const DairyList = enterpriseTypeList.filter(enterpriseType => enterpriseType.label.includes("Dairy"));
            if (selectedValues != null && selectedValues != '' && DairyList.length > 0) {
                let isAnyDairyType = false;
                DairyList.map(dairy => {
                    if (Array.isArray(selectedValues)) {
                        isAnyDairyType = selectedValues.filter(type => type == dairy.value) > 0 ? true : isAnyDairyType
                    }
                    else {
                        isAnyDairyType = selectedValues == dairy.value ? true : isAnyDairyType
                    }
                })

                if (isAnyDairyType) {
                    setOptionalPages_Effluent(true);
                }
                else {

                }
            }
        }
    }

    const saveFarmDetails = async () => {
        var noStockOnThisFarm = document.getElementById("noStockOnThisFarm").checked;
        let form = {
            Id: farmId,
            UniqueIdentifier: uniqueIdentifier,
            SupplyCompany: supplyCompany,
            SupplycompanyAccess: supplyCompanyAccess,
            RuralProfessionalOrganisation: ruralProfessionalOrganisation,
            RuralProfessional: ruralProfessional,
            RuralProfessionalAccess: ruralProfessionalAccess,
            OptionalPages_Effluent: optionalPages_Effluent,
            OptionalPages_FreshwaterIrrigation: optionalPages_FreshwaterIrrigation,
            OptionalPages_WinterGrazing: optionalPages_WinterGrazing,
            OptionalPages_Cropping: optionalPages_Cropping,
            OptionalPages_Biodiversity: optionalPages_Biodiversity,
            OptionalPages_GreenhouseGass: optionalPages_GreenhouseGass,
            OptionalPages_Biosecurity: optionalPages_Biosecurity,
            OptionalPages_ContaminantSelfEvaluation: optionalPages_ContaminantSelfEvaluation,
            Show_HistoricalActions: show_HistoricalActions,
            Show_SectionComment: show_SectionComment,
            FarmSystemType: farmSystemType,
            FarmingActivities: farmingActivities,
            IsNoStockOnThisFarm: noStockOnThisFarm,
            Enterprises: enterpriseTypeSelectedValues.toString(),
            UserId: userId,
            Address1: propertyDetails.Address1,
            Address2: propertyDetails.Address2,
            Address3: propertyDetails.Address3,
            ExecutiveSummaryComment: propertyDetails.ExecutiveSummaryComment,
            Address4: propertyDetails.Address4,
            FarmLocation: propertyDetails.FarmLocation,
            FarmStory: draftToHtml(convertToRaw(editorStateFarmStory.getCurrentContent())),
            FarmStoryGoals: draftToHtml(convertToRaw(editorStateFarmStoryGoals.getCurrentContent())), //farmStory.FarmStoryGoals,
            IntrestingFeatures: draftToHtml(convertToRaw(editorStateIntrestingFeatures.getCurrentContent())), //farmStory.IntrestingFeatures,
            Concerns: draftToHtml(convertToRaw(editorStateConcerns.getCurrentContent())), //farmStory.Concerns,
            RiparianAreas: draftToHtml(convertToRaw(editorStateRiparianAreas.getCurrentContent())), //tellUsAbout.RiparianAreas,
            AreasRetired: draftToHtml(convertToRaw(editorStateAreasRetired.getCurrentContent())), //tellUsAbout.AreasRetired,
            FencingOfWaterways: draftToHtml(convertToRaw(editorStateFencingOfWaterways.getCurrentContent())), //tellUsAbout.FencingOfWaterways,
            StockPolicy: draftToHtml(convertToRaw(editorStateStockPolicy.getCurrentContent())), //tellUsAbout.StockPolicy,
            Other: draftToHtml(convertToRaw(editorStateOther.getCurrentContent())), //tellUsAbout.Other,
            RegulatoryRequirementDetails: regulatoryRequirementDetails.RegulatoryRequirementDetails,
            NZBusinessNumber: propertyDetails.nzBusinessNumber,
            INFDPUniqueFreshwaterFarmPlanId: propertyDetails.infdpUniqueFreshwaterFarmPlanId,
            PropertyImageName: imageName,
            PropertyImagePhysicalName: imagePhysicalFilename,
            PropertyImagePath: imagePhysicalFilepath,
        }
        const response = await axios.post(
            '/api/enterprises/Save/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                toast.success("Enterprise & Farm Detail Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setSavingEnterprisesOptions(false);
                setSavingFarmStory(false);
                setSavingFarmSystem(false);
                setSavingAssociations(false);
                setSavingPropertyDetails(false);
                setSavingTellUsAbout(false);
                setSavingRegulatoryRequirementDetails(false);
            }
        }
    }

    const noIsresponsibleError = () => {
        if (!isHaveresponsible && enterpriseRowCount > 0) {
            toast.error("Please add a contact with is responsible for implementing plan to move forward ...", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        else if (isHaveresponsible && enterpriseRowCount === 0) {
            toast.error("Please add atleast one enterprise record for implementing plan to move forward ...", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        else if (!isHaveresponsible && enterpriseRowCount === 0) {
            toast.error("Please add a contact with is responsible and atleast one enterprise record for implementing plan to move forward ...", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
    }

    const handleRecordRowsAddRow = () => {
        const item = {
            createdDate: getParsedDate1(new Date()),
            documentDetail: "", id: 0, documentName: '', documentPhysicalName: '', documentPath: '', documentRelativePath: ''
        };
        const error = {
            fileError: ''
        };
        setFormErrors([...formErrors, error]);
        setDocumentUploadList([...documentUploadList, item]);
    };

    const handleRecordRowsRemoveSpecificRow = (idx) => () => {
        const tempRows = [...documentUploadList]
        const tempErrors = [...formErrors];
        tempRows.splice(idx, 1)
        tempErrors.splice(idx, 1)
        setDocumentUploadList(tempRows);
        setFormErrors(tempErrors);
    }

    const handleDateChange = (idx, date) => {
        const tempRows = [...documentUploadList];
        tempRows[idx].uploadDateText = getParsedDate(date);
        tempRows[idx].uploadDate = getDateFromString(getParsedDate(date));
        setDocumentUploadList(tempRows);
    };

    const getParsedDate1 = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "/" + mm + "/" + yyyy;
        return date.toString();
    }

    const getParsedDate = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "/" + mm + "/" + yyyy;
        return date.toString();
    }

    const getDateFromString = (date) => {
        var dd = date.split('/')[0];
        var mm = date.split('/')[1];
        var yyyy = date.split('/')[2];
        var newDate = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        return newDate;
    }

    const handleDetailsChange = idx => e => {
        const tempRows = [...documentUploadList];
        tempRows[idx].documentDetail = e.target.value;
        setDocumentUploadList(tempRows);
    };

    const handleRecordChange = async (e, idx) => {
        e.preventDefault();
        const tempErrors = [...formErrors];
        let reader = new FileReader();
        let file = e.target.files[0];
        const errors = {};
        if (file.type != 'application/pdf') {
            errors.fileError = "Only Pdf files can upload!";
            tempErrors[idx].fileError = "Only Pdf files can upload!";
        }
        else {
            tempErrors[idx].fileError = "";
        }
        setFormErrors(tempErrors);
        if (Object.keys(errors).length == 0) {
            if (file.type == 'application/pdf') {
                const formData = new FormData();
                formData.append("FarmId", farmId);
                formData.append("ReferenceId", farmId);
                formData.append("Type", uploadType);
                formData.append("FileName", e.target.files[0].name);
                formData.append("File", e.target.files[0]);
                formData.append("userId", userId);
                const response = await axios.post(
                    '/api/uploaddocument/UploadDocument/', formData,
                    {
                        headers: { "Content-type": "multipart/form-data", "FarmId": farmId, "ReferenceId": farmId, "Type": uploadType, "userId": userId, "FileName": e.target.files[0].name },
                        withCredentials: true
                    });
                if (response.data != null) {
                    if (response.data.status) {
                        const tempRows = [...documentUploadList];
                        tempRows[idx].documentName = response.data.content.DocumentName;
                        tempRows[idx].documentPhysicalName = response.data.content.DocumentPhysicalName;
                        tempRows[idx].documentPath = response.data.content.DocumentPath;
                        tempRows[idx].documentRelativePath = response.data.content.RelativeFilepath;
                        setDocumentUploadList(tempRows);
                    }
                }
            }
        }
        else {
            e.target.value = null;
        }
    }

    const handleBtnUploadClick = async (e, idx) => {
        e.preventDefault();
        inputFile[idx].click();
        return false;
    }

    const handleRecordRowsSubmit = async (e) => {
        
        let tempRecordUploadList = [...documentUploadList];
        let form = {
            ReferenceId: farmId,
            FarmId: farmId,
            UploadType: uploadType,
            userId: userId,
            Documents: []
        }
        for (var i = 0; i < tempRecordUploadList.length; i++) {
            if (tempRecordUploadList[i].documentName != '' && tempRecordUploadList[i].documentName != null && tempRecordUploadList[i].documentName != undefined) {
                var obj = {};
                obj.Id = tempRecordUploadList[i].id;
                obj.documentDetail = tempRecordUploadList[i].documentDetail;
                obj.documentName = tempRecordUploadList[i].documentName;
                obj.documentPhysicalName = tempRecordUploadList[i].documentPhysicalName;
                obj.documentPath = tempRecordUploadList[i].documentPath;
                obj.UploadDateText = tempRecordUploadList[i].uploadDate != null ? tempRecordUploadList[i].uploadDateText : "";
                form.Documents.push(obj);
            }
        }
        const response = await axios.post(
            '/api/upload/SaveDocuments/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                setTimeout(() => {
                    setDocumentUploadList(response.data.content);
                    let tempErrors = [];
                    setFormErrors(tempErrors);
                    response.data.content.forEach(function (element) {
                        const error = {
                            fileError: ''
                        };
                        tempErrors.push(error);
                    });
                    setFormErrors(tempErrors);
                }, 2000);
            }
        }
    };

    const handleMultMeatCompaniesChange = (e) => {
        setEnterpriseDetails({ ...enterpriseDetails, selectedCompanies: [] });
        let selectedCompany = '';
        setEnterpriseDetails({ ...enterpriseDetails, selectedCompanies: e });
        e.forEach(function (element) {
            if (selectedCompany == '') {
                selectedCompany = element.value;
            }
            else {
                selectedCompany = selectedCompany + ',' + element.value;
            }
        });

        setEnterpriseDetails({ ...enterpriseDetails, selectedCompanies: selectedCompany });

    }

    const CustomToastWithLink = (message) => (
        <div>
            <p>{message}</p>
        </div>
    );
    const customId = "custom-id-yes2";
    const showToastMessage = (e,message) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink(message), {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };
    let inputImageFile = ''; const [imageViewPopup, setImageViewPopup] = useState({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    const handleBtnImageUploadClick = async (e) => {
        e.preventDefault();
        inputImageFile.click();
        return false;
    }

    const handleImageViewPopup = (event, imageName, imageUrl) => {
        setImageViewPopup({ showImageViewPopup: true, imageName: imageName, imageUrl: imageUrl });
    }

    const handleImageViewPopupClose = (event) => {
        setImageViewPopup({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    }

    const handleImageChange = async (e) => {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];

        getBase64(file)
            .then(result => {
                let form = {
                    FileName: file.name.replace(/\.[^/.]+$/, ""),
                    Type: "Property",
                    Base64Image: result, FarmId: farmId
                }
                const response = axios.post(
                    '/api/upload/UploadImage/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    }).then(res => {
                        if (res.data != null) {
                            if (res.data.status) {
                                setImagePreviewUrl(res.data.content.RelativeFilepath);
                                setImagePhysicalFilename(res.data.content.PhysicalFilename);
                                setImagePhysicalFilepath(res.data.content.PhysicalFilepath);
                            }
                        }
                    });
            })
            .catch(err => {
                console.log(err);
            });

        reader.onloadend = () => {
            setImageName(file.name);
            setImageFile(file);
            setImagePreviewUrl(reader.result);
        }

        reader.readAsDataURL(file)
    }

    const getBase64 = async (file) => {
        return new Promise(resolve => {
            let fileInfo;
            let baseURL = "";
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    };

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{enterprises.SectionName}</h3></Col>
                { !loading &&
                    <Col>
                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                            <>
                        {(isHaveresponsible == true && enterpriseRowCount > 0) ?
                            <Button className="float-end btn-next-page" onClick={(section) => handleWizardChanged(enterprises.Section)}>Next <FaChevronRight /> </Button> :
                            <Button className="float-end btn-next-page-warning" onClick={noIsresponsibleError}>Next <FaChevronRight /> </Button>
                            }
                            </>
                        }
                        {(roleName != 'Admin' && saveRightsForNonItemFieldsAndTables == 'false') && isNextButtonVisible &&
                            <>
                                {(isHaveresponsible == true && enterpriseRowCount > 0) ?
                                <Button className="float-end btn-next-page" onClick={(section) => handleMoveToNextPage(enterprises.Section)}>Next <FaChevronRight /> </Button> :
                                    <Button className="float-end btn-next-page-warning" onClick={noIsresponsibleError}>Next <FaChevronRight /> </Button>
                                }
                            </>
                        }
                        {/*<Button className="float-end btn-next-page" onClick={(section) => handleWizardChangedBack(enterprises.Section)}>Back <FaChevronLeft /> </Button>*/}
                    </Col>
                }
            </Row>
            {loading ? <SpinnerContainer /> : <>
                <Row xs="2">
                    <Col>
                        {((supplyCompany != 0 && supplyCompany != undefined && supplyCompany != null) || (ruralProfessionalOrganisation != 0 && ruralProfessionalOrganisation != undefined && ruralProfessionalOrganisation != null)) &&
                            <Card className="my-4">
                                <CardHeader className="card-header d-flex align-items-center card-header-dark"><h5>Associations & Approved Program Membership</h5>
                                </CardHeader>
                                <br />
                                <CardBody>
                                    {supplyCompany != 0 && supplyCompany != undefined && supplyCompany != null &&
                                        <>  <Row>
                                            <Col sm="6">
                                                <FormGroup>
                                                    <Label className="label" for="name">Supply Company</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col sm="6">
                                                <FormGroup>
                                                    {enterprisesList.supplyCompanies == undefined && <p><em>Loading...</em></p>}
                                                    {enterprisesList.supplyCompanies != undefined && enterprisesList.supplyCompanies != null &&
                                                        <Input disabled={true} type="select" value={supplyCompany} onChange={(e) => setSupplyCompany(e.target.value)} name="supplyCompany" id="supplyCompany">
                                                            {enterprisesList.supplyCompanies.map(items =>
                                                                <option key={uuid()} value={items.id}>{items.name}</option>
                                                            )}
                                                        </Input>
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                            <Row>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label className="label" for="name">Supply Company Access</Label>
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        {enterprisesList.supplyCompanyAccesses == undefined && <p><em>Loading...</em></p>}
                                                        {enterprisesList.supplyCompanyAccesses != undefined && enterprisesList.supplyCompanyAccesses != null &&
                                                            <Input type="select" value={supplyCompanyAccess} onChange={(e) => setSupplyCompanyAccess(e.target.value)} name="supplyCompanyAccess" id="supplyCompanyAccess">
                                                                {enterprisesList.supplyCompanyAccesses.map(items =>
                                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                                )}
                                                            </Input>
                                                        }
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </>
                                    }
                                    {ruralProfessionalOrganisation != 0 && ruralProfessionalOrganisation != undefined && ruralProfessionalOrganisation != null &&
                                        <>
                                            <Row>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label className="label" for="name">Rural Professional Organisation</Label>
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        {enterprisesList.ruralProfessionalOrganisations == undefined && <p><em>Loading...</em></p>}
                                                        {enterprisesList.ruralProfessionalOrganisations != undefined && enterprisesList.ruralProfessionalOrganisations != null &&
                                                            <Input disabled={true} type="select" value={ruralProfessionalOrganisation} onChange={(e) => setRuralProfessionalOrganisation(e.target.value)} name="ruralProfessionalOrganisation" id="ruralProfessionalOrganisation">
                                                                {enterprisesList.ruralProfessionalOrganisations.map(items =>
                                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                                )}
                                                            </Input>
                                                        }
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label className="label" for="name">Rural Professional</Label>
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        {enterprisesList.ruralProfessionals == undefined && <p><em>Loading...</em></p>}
                                                        {enterprisesList.ruralProfessionals != undefined && enterprisesList.ruralProfessionals != null &&
                                                            <Input disabled={true} type="select" value={ruralProfessional} onChange={(e) => setRuralProfessional(e.target.value)} name="ruralProfessional" id="ruralProfessional">
                                                                {enterprisesList.ruralProfessionals.map(items =>
                                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                                )}
                                                            </Input>
                                                        }
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label className="label" for="name">Rural Professional Access</Label>
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        {enterprisesList.ruralProfessionalAccesses == undefined && <p><em>Loading...</em></p>}
                                                        {enterprisesList.ruralProfessionalAccesses != undefined && enterprisesList.ruralProfessionalAccesses != null &&
                                                            <Input type="select" value={ruralProfessionalAccess} onChange={(e) => setRuralProfessionalAccess(e.target.value)} name="ruralProfessionalAccess" id="ruralProfessionalAccess">
                                                                {enterprisesList.ruralProfessionalAccesses.map(items =>
                                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                                )}
                                                            </Input>
                                                        }
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </>
                                    }
                                    <Row>
                                        <Col>
                                            {savingAssociations ?
                                                <Button style={{ float: "right" }} onClick={handleAssociationsSubmit}
                                                    color="success"
                                                    disabled
                                                >
                                                    <Row>
                                                        <Col sm="8">
                                                            <span>
                                                                {' '}Saving
                                                            </span>
                                                        </Col>
                                                        <Col sm="4">
                                                            <Spinner size="sm">
                                                                Saving...
                                                            </Spinner>
                                                        </Col>
                                                    </Row>
                                                </Button>
                                                :
                                                <Button style={{ float: "right" }} onClick={handleAssociationsSubmit} color="success" size="sm">
                                                    Save
                                                </Button>
                                            }
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        }
                        <CouncilAndLandInfo userId={userId}></CouncilAndLandInfo>
                        <Card className="my-4">
                            <CardHeader className="d-flex card-header-dark">
                                <h5>Other Regulatory Requirements Covered</h5>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Are you using this Fresh Water Farm plan to meet any other regulatory requirements</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="select" value={regulatoryRequirementDetails.FWFPToMeetAnyOtherRegulatoryRequirement} onChange={(e) => setRegulatoryRequirementDetails({ ...regulatoryRequirementDetails, FWFPToMeetAnyOtherRegulatoryRequirement: e.target.value })} name="FWFPToMeetAnyOtherRegulatoryRequirement" id="FWFPToMeetAnyOtherRegulatoryRequirement">
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row style={{ display:"none" }}>
                                    <Col sm="6">
                                        <FormGroup>
                                            <span className="label-note">Detail any regulatory requirements which this Fresh Water Farm Plan (when certified) will also meet. Examples include Regional Plan Rules, National Environmental Standards, or Regulations made under section 360 of the act</span>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="textarea" value={regulatoryRequirementDetails.RegulatoryRequirementDetails} onChange={(e) => setRegulatoryRequirementDetails({ ...regulatoryRequirementDetails, RegulatoryRequirementDetails: e.target.value })} name="RegulatoryRequirementDetails" id="RegulatoryRequirementDetails" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {
                                    regulatoryRequirementDetails.FWFPToMeetAnyOtherRegulatoryRequirement == "Yes" && <>
                                    <Row>
                                            <Col>
                                                {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                    <>
                                                <button onClick={handleRegulatoryRequirementRowsAddRow} type="button" id="btnUpdate" className="btn btn-sm btn-pluse-light">
                                                <FaPlus />
                                                    </button>
                                                    </>
                                                }
                                        </Col>
                                    </Row>
                                        <br />
                                        <Row>
                                            <Col>

                                                <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-left"> Regulatory Requirement </th>
                                                            <th className="text-left"> Condition </th>
                                                            <th />
                                                        </tr>
                                                    </thead>
                                                    <tbody className="text-left">
                                                        {regulatoryRequirementsRows != undefined && regulatoryRequirementsRows.map((item, idx) => (
                                                            <tr id="addr0" key={idx}>
                                                                <td style={{ display: "none" }}>{regulatoryRequirementsRows[idx].id}</td>
                                                                <td style={{ width: "25%" }}>
                                                                    <input className="form-control" type="text" value={regulatoryRequirementsRows[idx].regulatoryRequirement} maxLength="1000" onChange={handleRegulatoryRequirementChange(idx)} name="regulatoryRequirement" id="regulatoryRequirement" autoComplete="new-password" />
                                                                </td>
                                                                <td style={{ width: "25%" }}>
                                                                    <input className="form-control" type="text" value={regulatoryRequirementsRows[idx].condition} maxLength="1000" onChange={handleRegulatoryRequirementConditionChange(idx)} name="condition" id="condition" autoComplete="new-password" />
                                                                </td>
                                                                <td style={{ width: "5%" }}>
                                                                    {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                        <>
                                                                    <button style={{ float: "right" }} onClick={handleRegulatoryRequirementRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger">
                                                                        <FaTrash />
                                                                        </button>
                                                                        </>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                            </Col>
                                        </Row>
                                    </> 
                                }
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Are there any new phsyical works being planned for the farm?</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="select" value={regulatoryRequirementDetails.IsAnyNewPhsyicalWorks} onChange={(e) => setRegulatoryRequirementDetails({ ...regulatoryRequirementDetails, IsAnyNewPhsyicalWorks: e.target.value })} name="IsAnyNewPhsyicalWorks" id="IsAnyNewPhsyicalWorks">
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {
                                    regulatoryRequirementDetails.IsAnyNewPhsyicalWorks == "Yes" && <>
                                        <Row>
                                            <Col>
                                                <span className="label-note"> Please detail below and attach relevant document if needed.</span>
                                                <FormGroup>
                                                    <Input type="textarea" value={regulatoryRequirementDetails.AnyNewPhsyicalWorksDetails} onChange={(e) => setRegulatoryRequirementDetails({ ...regulatoryRequirementDetails, AnyNewPhsyicalWorksDetails: e.target.value })} name="AnyNewPhsyicalWorksDetails" id="AnyNewPhsyicalWorksDetails"/>
                                                </FormGroup>

                                                <div>
                                                    <Row>
                                                        <Col>
                                                            {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                <>
                                                            <button onClick={handleRecordRowsAddRow} type="button" id="btnUpdate" className="btn btn-sm btn-pluse-light">
                                                                <FaPlus />
                                                                </button>
                                                                </>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <br />
                                                    <Row>
                                                        <Col sm="12">
                                                            <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                                <thead className="text-left">
                                                                    <tr>
                                                                        <th className="text-left"> Date</th>
                                                                        <th className="text-left"> Details </th>
                                                                        <th className="text-left"> Attachment </th>
                                                                        <th />
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="text-left">
                                                                    {documentUploadList.map((item, idx) => (
                                                                        <tr id="records" key={idx}>
                                                                            <td style={{ display: "none" }}>{documentUploadList[idx].id}</td>
                                                                            <td style={{ width: "15%" }}>
                                                                                <DatePicker selected={documentUploadList[idx].uploadDate != null ? getDateFromString(moment(documentUploadList[idx].uploadDate).format("DD/MM/YYYY")) : null} onChange={(date) => handleDateChange(idx, date)} name="uploadDate" dateFormat="dd/MM/yyyy" className="form-control" />
                                                                            </td>
                                                                            <td style={{ width: "45%" }}>
                                                                                <input type="textarea" name="documentDetail" value={documentUploadList[idx].documentDetail} onChange={handleDetailsChange(idx)} className="form-control" />
                                                                            </td>
                                                                            <td style={{ width: "15%" }}>
                                                                                {documentUploadList[idx].documentRelativePath != null && documentUploadList[idx].documentRelativePath != '' ?
                                                                                    <Row>
                                                                                        <Col>
                                                                                            <a href={documentUploadList[idx].documentRelativePath} target='_blank'>
                                                                                                <img src="/images/PDF_icon.png" className="PDF_icon" ></img>
                                                                                            </a>
                                                                                        </Col>
                                                                                        <Col>
                                                                                            {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                                                <>
                                                                                                <Button style={{ float: `right` }} color="warning" size="sm" onClick={(e) => handleBtnUploadClick(e, idx)} ><FaUpload /></Button>
                                                                                                </>
                                                                                            }
                                                                                        </Col>
                                                                                    </Row>
                                                                                    :
                                                                                    <>
                                                                                    {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                                    <>
                                                                                    <Button style={{ float: `right` }} color="success" size="sm" onClick={(e) => handleBtnUploadClick(e, idx)} ><FaUpload /></Button>
                                                                                            </>
                                                                                        }
                                                                                    </>
                                                                                }
                                                                                <br />
                                                                                <input style={{ float: `right`, display: 'none' }}
                                                                                    ref={input => {
                                                                                        inputFile[idx] = input;
                                                                                    }}
                                                                                    type="file" name="attachment" className="form-control" onChange={(e) => handleRecordChange(e, idx)} />
                                                                                {formErrors.length > 0 && formErrors[idx] != undefined && formErrors[idx].fileError != undefined &&
                                                                                    <p className="errorMessage">{formErrors[idx].fileError}</p>
                                                                                }
                                                                            </td>
                                                                            <td style={{ width: "5%" }}>
                                                                                <button style={{ float: "right" }} onClick={handleRecordRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger">
                                                                                    <FaTrash />
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </Col>
                                                        
                                                    </Row>
                                                </div>
                                            </Col>

                                        </Row>
                                        
                                    </>
                                }
                                <Row>
                                    <Col>
                                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                            <>
                                                {savingRegulatoryRequirementDetails ?
                                                    <Button style={{ float: "right" }} onClick={handleRegulatoryRequirementDetailsSubmit}
                                                        color="success"
                                                        disabled
                                                    >
                                                        <Row>
                                                            <Col sm="8">
                                                                <span>
                                                                    {' '}Saving
                                                                </span>
                                                            </Col>
                                                            <Col sm="4">
                                                                <Spinner size="sm">
                                                                    Saving...
                                                                </Spinner>
                                                            </Col>
                                                        </Row>
                                                    </Button>
                                                    :
                                                    <Button style={{ float: "right" }} onClick={handleRegulatoryRequirementDetailsSubmit} color="success" size="sm">
                                                        Save
                                                    </Button>
                                                }
                                            </>
                                        }
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card className="my-4">
                            <CardHeader className="d-flex card-header-dark">
                                <h5>Property Details</h5>
                            </CardHeader>
                            <br />
                            <CardBody>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Unique Identifier</Label> <br /><span className="label-note"> (note system ID used by the FWFP system)</span>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="text" disabled={true} value={uniqueIdentifier} onChange={(e) => setUniqueIdentifier(e.target.value)} name="uniqueIdentifier" id="uniqueIdentifier" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">INFDP Unique Freshwater Farm Plan ID</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="text" value={propertyDetails.infdpUniqueFreshwaterFarmPlanId} onChange={(e) => setPropertyDetails({ ...propertyDetails, infdpUniqueFreshwaterFarmPlanId: e.target.value })} name="infdpUniqueFreshwaterFarmPlanId" id="infdpUniqueFreshwaterFarmPlanId" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Farm or Business Name, Maori land trust or Maori incorporation</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="text" disabled={true} value={propertyDetails.Name} onChange={(e) => setPropertyDetails({ ...propertyDetails, Name: e.target.value })} name="Name" id="Name" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row style={{display:"none"}}>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">NZ business number</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="text" value={propertyDetails.nzBusinessNumber} onChange={(e) => setPropertyDetails({ ...propertyDetails, nzBusinessNumber: e.target.value })} name="nzBusinessNumber" id="nzBusinessNumber" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Address 1</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="textarea" value={propertyDetails.Address1} onChange={(e) => setPropertyDetails({ ...propertyDetails, Address1: e.target.value })} name="Address1" id="Address1" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Address 2</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="textarea" value={propertyDetails.Address2} onChange={(e) => setPropertyDetails({ ...propertyDetails, Address2: e.target.value })} name="Address2" id="Address2" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Address Town / City</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="textarea" value={propertyDetails.Address3} onChange={(e) => setPropertyDetails({ ...propertyDetails, Address3: e.target.value })} name="Address3" id="Address3" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Address Postcode</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="text" value={propertyDetails.Address4} onChange={(e) => setPropertyDetails({ ...propertyDetails, Address4: e.target.value })} name="Address4" id="Address4" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row style={{ display: "none" }}>
                                    <Col sm="6">
                                        <FormGroup>
                                            (Please indicate Iwi, Hapū or Rūnanga)<br />
                                            <Label className="label" for="name">Farm location</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="text" value={propertyDetails.FarmLocation} onChange={(e) => setPropertyDetails({ ...propertyDetails, FarmLocation: e.target.value })} name="FarmLocation" id="FarmLocation" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Executive Summary Comment</Label><br />
                                            <span>The complete FWFP report includes an automated executive summary letter. Information in this field is included as a paragraph in the letter, but it is not essential for the letter.</span>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="textarea" value={propertyDetails.ExecutiveSummaryComment} onChange={(e) => setPropertyDetails({ ...propertyDetails, ExecutiveSummaryComment: e.target.value })} name="ExecutiveSummaryComment" id="ExecutiveSummaryComment" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            
                                            <Label className="label" for="name">Upload a photo of your property (Optional).</Label>
                                            <br />This photo will be used in the report to introduce your property to readers.
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <Col>
                                            {imagePreviewUrl && <img className="settings-image-style" src={imagePreviewUrl} onClick={(event, imageName, imageUrl) => handleImageViewPopup(event, imageName, imagePreviewUrl)} />}
                                            <br />
                                            {imagePreviewUrl ?
                                                <Button color="warning" size="sm" onClick={handleBtnImageUploadClick} ><FaUpload /> Modifiy Image</Button> :
                                                <Button color="success" size="sm" onClick={handleBtnImageUploadClick} ><FaUpload /> Upload Image</Button>}
                                            <input style={{ display: 'none' }}
                                                ref={input => {
                                                    inputImageFile = input;
                                                }}
                                                className="fileInput" id="fileUpload" type="file" onChange={handleImageChange} />
                                        </Col>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                            <>
                                        {savingPropertyDetails ?
                                            <Button style={{ float: "right" }} onClick={handlePropertyDetailsSubmit}
                                                color="success"
                                                disabled
                                            >
                                                <Row>
                                                    <Col sm="8">
                                                        <span>
                                                            {' '}Saving
                                                        </span>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Spinner size="sm">
                                                            Saving...
                                                        </Spinner>
                                                    </Col>
                                                </Row>
                                            </Button>
                                            :
                                            <Button style={{ float: "right" }} onClick={handlePropertyDetailsSubmit} color="success" size="sm">
                                                Save
                                            </Button>
                                            }
                                            </>
                                        }
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                       
                    </Col>
                    <Col>
                        <Card className="my-4">
                            <CardHeader className="card-header card-header-dark d-flex justify-content-between align-items-center">
                                <h5 >
                                    Enterprises & Farming Activities&nbsp;&nbsp;&nbsp;
                                    <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-22" onClick={(e) => e.stopPropagation()} />
                                </h5>
                                <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                    id="my-tooltip-22"
                                    place="top"
                                    variant="info"
                                    render={({ content, activeAnchor }) => (
                                        <>
                                            <Row>
                                                <Col>
                                                    <p style={{ fontWeight: "lighter" }}>
                                                        For more information on Enterprise and Farming details <a href="https://freshwaterfarmplan.co.nz/fwfp-support/enterprise-farm-detail/" target="_blank" rel="noreferrer">Click Here</a>
                                                    </p>
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                />
                                {(roleName == 'Admin' || isAddEditItem == 'true') &&
                                                <>
                                        <button onClick={handleEnterpriseRowsAddRow} type="button" id="btnUpdate" className="btn btn-sm btn-pluse">
                                            <FaPlus />
                                        </button>
                                    </>
                                }
                            </CardHeader>
                            <br />
                            <CardBody>
                                <Row>
                                    <Col>

                                        <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                            <thead>
                                                <tr>
                                                    <th className="text-left"> Category (Land Use) </th>
                                                    <th className="text-left"> Enterprise (Land Use sub-category) </th>
                                                    <th className="text-left"> Enterprise Type </th>
                                                    <th className="text-left"> Enterprise / Farming Activities Description </th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody className="text-left">
                                                {enterpriseRows.map((item, idx) => (
                                                    <tr id="addr0" key={idx}>
                                                        <td style={{ display: "none" }}>{enterpriseRows[idx].id}</td>
                                                        <td style={{ width: "25%" }}>
                                                            {enterpriseCategoryList == undefined && <p><em>Loading...</em></p>}
                                                            {enterpriseCategoryList != undefined && enterpriseCategoryList != null &&
                                                                <Input type="select" value={enterpriseRows[idx].enterpriseCategory} onChange={handleEnterpriseCategoryChange(idx)} name="enterpriseCategory" id="enterpriseCategory">
                                                                    {enterpriseCategoryList.map(items =>
                                                                        <option key={uuid()} value={items.id}>{items.name}</option>
                                                                    )}
                                                                </Input>
                                                            }
                                                        </td>
                                                        <td style={{ width: "25%" }}>
                                                            {enterpriseTypeList == undefined && <p><em>Loading...</em></p>}
                                                            {enterpriseTypeList != undefined && enterpriseTypeList != null &&
                                                                <Input type="select" value={enterpriseRows[idx].enterpriseType} onChange={handleEnterpriseTypeChange(idx)} name="enterpriseType" id="enterpriseType">
                                                                    {enterpriseTypeList.filter(x => x.category == enterpriseRows[idx].enterpriseCategory).map(items =>
                                                                        <option key={uuid()} value={items.id}>{items.name}</option>
                                                                    )}
                                                                </Input>
                                                            }
                                                        </td>
                                                        <td style={{ width: "25%" }}>
                                                            <input className="form-control" type="text" value={enterpriseRows[idx].farmingActivity} maxLength="20" onChange={handleFarmingActivityChange(idx)} name="farmingActivity" id="farmingActivity" autoComplete="new-password" />
                                                        </td>
                                                        <td style={{ width: "45%" }}>
                                                            <textarea name="overviewOfFarmingActivities"
                                                                value={enterpriseRows[idx].overviewOfFarmingActivities}
                                                                onChange={handleOverviewOfFarmingActivitiesChange(idx)}
                                                                className="form-control"></textarea>
                                                        </td>
                                                        <td style={{ width: "5%" }}>
                                                            {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                <>
                                                            {!enterpriseRows[idx].isLUPresent && 
                                                                <button style={{ float: "right" }} onClick={handleEnterpriseRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger">
                                                                    <FaTrash />
                                                                </button>
                                                                }
                                                                </>
                                                            }
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                    </Col>
                                </Row>
                                {enterpriseDetails.IsPastorallanduse &&
                                    <Row>
                                        <Col sm="12">
                                            <Row>
                                                <Col sm="6">
                                                    <Row>
                                                        <Col sm="12">
                                                            <FormGroup>
                                                                <Label className="label" for="IsAnyMeatCompany">Do you supply any Meat Companies?</Label>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="4">
                                                            <FormGroup>
                                                                <Input type="select" value={enterpriseDetails.IsAnyMeatCompany} onChange={(e) => setEnterpriseDetails({ ...enterpriseDetails, IsAnyMeatCompany: e.target.value })} name="IsAnyMeatCompany" id="IsAnyMeatCompany">
                                                                    <option value="Yes">Yes</option>
                                                                    <option value="No">No</option>
                                                                </Input>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                {enterpriseDetails.IsAnyMeatCompany == 'Yes' && 
                                                    <Col sm="6">
                                                        <Row>
                                                            <Col sm="12">
                                                                <FormGroup>
                                                                    <Label className="label" for="IsAnyMeatCompany">Please Specify :</Label>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col sm="12">
                                                                <FormGroup>
                                                                    <Select
                                                                        id="MeatComapny"
                                                                        name="MeatComapny"
                                                                        closeMenuOnSelect={false}
                                                                        className="dropdown"
                                                                        placeholder="Select Meat Comapny"
                                                                        defaultValue={enterpriseDetails.selectedCompanies}
                                                                        options={enterpriseDetails.MeatCompanyList}
                                                                        onChange={handleMultMeatCompaniesChange}
                                                                        isClearable isMulti hideSelectedOptions={false}
                                                                        components={{
                                                                            Option
                                                                        }}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                }
                                             </Row>
                                        </Col>
                                    </Row>
                                }
                                {
                                    isHavingFarmWriteAccess &&
                                    <>
                                        <Row>
                                            <Col sm="9">
                                                <Label className="label" for="name">Additional Mapping Pages and Extra Features</Label>
                                                <label>
                                                    Access FARM SETTINGS and enable additional mapping if your property has irrigation, effluent management, cropping, or you would to manage Biosecurity, Biodiversity, or Greenhouse Gas in your farm plan.
                                                    Some additional features are also available to include extra information in your plan if you wish, but it is not required.
                                                </label>
                                            </Col>
                                            <Col sm="3">
                                                <br /><br />
                                                <Button style={{ float: "left", fontSize: "18px" }} onClick={gotoFarmSettings} color="success" size="sm">
                                                    Farm Settings<FaChevronRight />
                                                </Button>
                                            </Col>
                                        </Row>
                                    </>
                                }
                                <Row>
                                    <Col>
                                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                            <>
                                        {savingEnterprises ?
                                            <Button style={{ float: "right" }} onClick={handleEnterpriseRowsSubmit}
                                                color="success"
                                                disabled
                                            >
                                                <Row>
                                                    <Col sm="8">
                                                        <span>
                                                            {' '}Saving
                                                        </span>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Spinner size="sm">
                                                            Saving...
                                                        </Spinner>
                                                    </Col>
                                                </Row>
                                            </Button>
                                            :
                                            <Button style={{ float: "right" }} onClick={handleEnterpriseRowsSubmit} color="success" size="sm">
                                                Save
                                            </Button>
                                            }
                                            </>
                                        }
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card className="my-4" style={{ display:"none" }}>
                            <CardHeader className="d-flex card-header-dark">
                                <h5>Optional Pages and Add On's&nbsp;&nbsp;&nbsp;
                                    <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-23" onClick={(e) => e.stopPropagation()} /></h5>
                                <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                    id="my-tooltip-23"
                                    place="top"
                                    variant="info"
                                    render={({ content, activeAnchor }) => (
                                        <>
                                            <Row>
                                                <Col>
                                                    <p style={{ fontWeight: "lighter" }}>
                                                        For more information on Optional Pages and add on's <a href="https://freshwaterfarmplan.co.nz/fwfp-support/optional-pages/" target="_blank" rel="noreferrer">Click Here</a>
                                                    </p>
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                />
                            </CardHeader>
                            <br />
                            <CardBody>
                                <Row>
                                    <Col>
                                        <Row >
                                            <Col>
                                                <Label className="label" for="name">Add-on's and Optional Pages</Label>

                                                <Row>
                                                    <Col>
                                                        <Row>
                                                            <Col sm="2">
                                                                <Input type="checkbox" checked={optionalPages_Cropping} onChange={(e) => setOptionalPages_Cropping(!optionalPages_Cropping)} name="optionalPages_Cropping" id="optionalPages_Cropping" />
                                                            </Col>
                                                            <Col sm="10">
                                                                <Label>Cropping and Cultivation</Label>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col>
                                                        <Row>
                                                            <Col sm="2">
                                                                {enterpriseTypeListSelectedValues.filter(enterpriseType => enterpriseType.label.includes("Dairy")).length > 0 ?
                                                                    < Input type="checkbox" checked={optionalPages_Effluent} onChange={(e) => setOptionalPages_Effluent(!optionalPages_Effluent)} name="optionalPages_Effluent" id="optionalPages_Effluent" disabled />
                                                                    : < Input type="checkbox" checked={optionalPages_Effluent} onChange={(e) => setOptionalPages_Effluent(!optionalPages_Effluent)} name="optionalPages_Effluent" id="optionalPages_Effluent" />
                                                                }
                                                            </Col>
                                                            <Col sm="10">
                                                                <Label>Effluent</Label>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col>
                                                        <Row>
                                                            <Col sm="2">
                                                                <Input type="checkbox" checked={optionalPages_Biodiversity} onChange={(e) => setOptionalPages_Biodiversity(!optionalPages_Biodiversity)} name="optionalPages_Biodiversity" id="optionalPages_Biodiversity" />
                                                            </Col>
                                                            <Col sm="10">
                                                                <Label>Biodiversity</Label>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Row>
                                                            <Col sm="2">
                                                                <Input type="checkbox" checked={optionalPages_FreshwaterIrrigation} onChange={(e) => setOptionalPages_FreshwaterIrrigation(!optionalPages_FreshwaterIrrigation)} name="optionalPages_FreshwaterIrrigation" id="optionalPages_FreshwaterIrrigation" />
                                                            </Col>
                                                            <Col sm="10">
                                                                <Label>Irrigation</Label>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col>
                                                        <Row>
                                                            <Col sm="2">
                                                                <Input type="checkbox" checked={optionalPages_WinterGrazing} onChange={(e) => setOptionalPages_WinterGrazing(!optionalPages_WinterGrazing)} name="optionalPages_WinterGrazing" id="optionalPages_WinterGrazing" />
                                                            </Col>
                                                            <Col sm="10">
                                                                <Label>Intensive Winter Grazing</Label>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col>
                                                        <Row>
                                                            <Col sm="2">
                                                                <Input type="checkbox" checked={optionalPages_GreenhouseGass} onChange={(e) => setOptionalPages_GreenhouseGass(!optionalPages_GreenhouseGass)} name="optionalPages_GreenhouseGass" id="optionalPages_GreenhouseGass" />
                                                            </Col>
                                                            <Col sm="10">
                                                                <Label>Greenhouse Gasses</Label>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="4">
                                                        <Row>
                                                            <Col sm="2">
                                                                <Input type="checkbox" checked={optionalPages_Biosecurity} onChange={(e) => setOptionalPages_Biosecurity(!optionalPages_Biosecurity)} name="optionalPages_Biosecurity" id="optionalPages_Biosecurity" />
                                                            </Col>
                                                            <Col sm="10">
                                                                <Label>Biosecurity</Label>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Row>
                                                            <Col sm="2">
                                                                <Input type="checkbox" checked={optionalPages_ContaminantSelfEvaluation} onChange={(e) => setOptionalPages_ContaminantSelfEvaluation(!optionalPages_ContaminantSelfEvaluation)} name="optionalPages_ContaminantSelfEvaluation" id="optionalPages_ContaminantSelfEvaluation" />
                                                            </Col>
                                                            <Col sm="10">
                                                                <Label>Contaminant Self Evaluation</Label>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Row>
                                                            <Col sm="2">
                                                                <Input type="checkbox" checked={show_SectionComment} onChange={(e) => setShow_SectionComment(!show_SectionComment)} name="show_SectionComment" id="show_SectionComment" />
                                                            </Col>
                                                            <Col sm="10">
                                                                <Label>Show Section Comment</Label> 
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="4">
                                                        <Row>
                                                            <Col sm="2">
                                                                <Input type="checkbox" checked={show_HistoricalActions} onChange={(e) => setShow_HistoricalActions(!show_HistoricalActions)} name="show_HistoricalActions" id="show_HistoricalActions" />
                                                            </Col>
                                                            <Col sm="10">
                                                                <Label>Enable Historical Actions <span style={{ fontSize: "11px", textTransform: "lowercase" }}>(For farms to show action by action history and completion)</span></Label>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                            <>
                                        {savingEnterprisesOptions ?
                                            <Button style={{ float: "right" }} onClick={handleEnterprisesOptionsSubmit}
                                                color="success"
                                                disabled
                                            >
                                                <Row>
                                                    <Col sm="8">
                                                        <span>
                                                            {' '}Saving
                                                        </span>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Spinner size="sm">
                                                            Saving...
                                                        </Spinner>
                                                    </Col>
                                                </Row>
                                            </Button>
                                            :
                                            <Button style={{ float: "right" }} onClick={handleEnterprisesOptionsSubmit} color="success" size="sm">
                                                Save
                                            </Button>
                                            }
                                            </>
                                        }
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card className="my-4" style={{ display: "none"}}>
                            <CardHeader className="card-header-dark"><h5>Farm System</h5></CardHeader>
                            <br />
                            <CardBody>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Farm System Type</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="text" value={farmSystemType} onChange={(e) => setFarmSystemType(e.target.value)} name="farmSystemType" id="farmSystemType" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Predominant Farming Activities</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="textarea" onChange={(e) => setFarmingActivities(e.target.value)} value={farmingActivities} name="farmingActivities" id="farmingActivities" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <table style={{ float: "right", marginTop: "10px" }} className="table table-bordered" id="tab_logic">
                                            <thead>
                                                <tr>
                                                    <th className="text-left"> Total Area (ha) </th>
                                                    <th className="text-left"> Lease Area (ha) </th>
                                                    <th className="text-left"> Irrigated Area (ha) </th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: "33%" }}>
                                                        <input type="text" disabled name="totalArea" value={totalArea == "0" ? "" : totalArea} className="form-control" />
                                                    </td>
                                                    <td style={{ width: "33%" }}>
                                                        <input type="text" disabled name="leaseArea" value={leaseArea == "0" ? "" : leaseArea} className="form-control" />
                                                    </td>
                                                    <td style={{ width: "33%" }}>
                                                        <input type="text" disabled name="irrigatedArea" value={irrigatedArea == "0" ? "" : irrigatedArea} className="form-control" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {savingFarmSystem ?
                                            <Button style={{ float: "right" }} onClick={handleFarmSystemSubmit}
                                                color="success"
                                                disabled
                                            >
                                                <Row>
                                                    <Col sm="6">
                                                        <span>
                                                            {' '}Saving
                                                        </span>
                                                    </Col>
                                                    <Col sm="6">
                                                        <Spinner size="sm">
                                                            Saving...
                                                        </Spinner>
                                                    </Col>
                                                </Row>
                                            </Button>
                                            :
                                            <Button style={{ float: "right" }} onClick={handleFarmSystemSubmit} color="success" size="sm">
                                                Save
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card className="my-4">
                            <CardHeader className="card-header-dark"><h5>Farm Story</h5></CardHeader>
                            <br />
                            <CardBody>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">History</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setFarmStory({ ...farmStory, FarmStory: e.target.value })} value={farmStory.FarmStory} name="FarmStory" id="FarmStory" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateFarmStory}
                                                onEditorStateChange={setEditorStateFarmStory}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Potential Goals</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setFarmStory({ ...farmStory, FarmStoryGoals: e.target.value })} value={farmStory.FarmStoryGoals} name="FarmStoryGoals" id="FarmStoryGoals" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateFarmStoryGoals}
                                                onEditorStateChange={setEditorStateFarmStoryGoals}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Interesting Features</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setFarmStory({ ...farmStory, IntrestingFeatures: e.target.value })} value={farmStory.IntrestingFeatures} name="IntrestingFeatures" id="IntrestingFeatures" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateIntrestingFeatures}
                                                onEditorStateChange={setEditorStateIntrestingFeatures}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Any concerns/worries</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setFarmStory({ ...farmStory, Concerns: e.target.value })} value={farmStory.Concerns} name="Concerns" id="Concerns" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateConcerns}
                                                onEditorStateChange={setEditorStateConcerns}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                            <>
                                        {savingFarmStory ?
                                            <Button style={{ float: "right" }} onClick={handleFarmStorySubmit}
                                                color="success"
                                                disabled
                                            >
                                                <Row>
                                                    <Col sm="8">
                                                        <span>
                                                            {' '}Saving
                                                        </span>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Spinner size="sm">
                                                            Saving...
                                                        </Spinner>
                                                    </Col>
                                                </Row>
                                            </Button>
                                            :
                                            <Button style={{ float: "right" }} onClick={handleFarmStorySubmit} color="success" size="sm">
                                                Save
                                            </Button>
                                            }
                                            </>
                                        }
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card className="my-4">
                            <CardHeader className="card-header-dark"><h5>Tell us about the work you have already done</h5></CardHeader>
                            <br />
                            <CardBody>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Riparian areas/Wetlands</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setTellUsAbout({ ...tellUsAbout, RiparianAreas: e.target.value })} value={tellUsAbout.RiparianAreas} name="RiparianAreas" id="RiparianAreas" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateRiparianAreas}
                                                onEditorStateChange={setEditorStateRiparianAreas}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Areas that have been retired (QEII)</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setTellUsAbout({ ...tellUsAbout, AreasRetired: e.target.value })} value={tellUsAbout.AreasRetired} name="AreasRetired" id="AreasRetired" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateAreasRetired}
                                                onEditorStateChange={setEditorStateAreasRetired}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Fencing of Waterways</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setTellUsAbout({ ...tellUsAbout, FencingOfWaterways: e.target.value })} value={tellUsAbout.FencingOfWaterways} name="FencingOfWaterways" id="FencingOfWaterways" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateFencingOfWaterways}
                                                onEditorStateChange={setEditorStateFencingOfWaterways}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Stock Policy</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setTellUsAbout({ ...tellUsAbout, StockPolicy: e.target.value })} value={tellUsAbout.StockPolicy} name="StockPolicy" id="StockPolicy" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateStockPolicy}
                                                onEditorStateChange={setEditorStateStockPolicy}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Other</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateOther}
                                                onEditorStateChange={setEditorStateOther}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                            {/*<Input type="textarea" onChange={(e) => setTellUsAbout({ ...tellUsAbout, Other: e.target.value })} value={tellUsAbout.Other} name="Other" id="Other" />*/}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                            <>
                                        {savingTellUsAbout ?
                                            <Button style={{ float: "right" }} onClick={handleTellUsAboutSubmit}
                                                color="success"
                                                disabled
                                            >
                                                <Row>
                                                    <Col sm="8">
                                                        <span>
                                                            {' '}Saving
                                                        </span>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Spinner size="sm">
                                                            Saving...
                                                        </Spinner>
                                                    </Col>
                                                </Row>
                                            </Button>
                                            :
                                            <Button style={{ float: "right" }} onClick={handleTellUsAboutSubmit} color="success" size="sm">
                                                Save
                                            </Button>
                                            }
                                            </>
                                        }
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <StockNumbers userId={userId}></StockNumbers>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Contacts userId={userId} checkAlreadyIsresponsible={checkAlreadyIsresponsibleChecked}></Contacts>
                    </Col>
                    
                </Row>
            </>
            }
            <Modal isOpen={imageViewPopup.showImageViewPopup} size="lg" className="imageViewPopup">
                <ModalHeader toggle={handleImageViewPopupClose} >{imageViewPopup.imageName}</ModalHeader>
                <ModalBody>
                    <img src={imageViewPopup.imageUrl} className="item-image-popup" alt={imageViewPopup.imageName} ></img>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleImageViewPopupClose}>Close</Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default Enterprises;